export const loading = {
  error_description: "Sorry, we've encountered a problem loading your data. Please <nobr>try refreshing the page</nobr>.<br/>If this problem persists, please call us at <nobr>{{contactNumber}}</nobr> <nobr>or email us at</nobr><br/><email />.",
  error_tile: 'Error',
  message: 'We are getting your data from a safe place.',
  title: 'Loading...',
} as const;

export type LoadingNamespace = Record<keyof typeof loading, string>;
